export const IMPACT_STATUSES = ["Pending", "Reported", "Failed", "TimedOut"];
export const APPLY_STATUSES = ["NotRequested", "Pending", "Applied", "Failed", "TimedOut"];
export const FAILURE_CODES = ["InvalidRule", "Unrecognized"];
const PREVIEW_STATUSES = ["ImpactPending", "ImpactReady"];
const WAITING_STATUSES = ["ImpactPending", "Running"];
// CONSTRAINT: no "Cancelled" here. This list drives the modal's `completed` emit, which reloads the contact record,
// and a cancelled request changed nothing on it.
const TERMINAL_STATUSES = ["Completed", "PartialFailure"];
const CANCELLED_STATUS = "Cancelled";
export function stepForStatus(status) {
    if (status === CANCELLED_STATUS)
        return "cancelled";
    return PREVIEW_STATUSES.includes(status) ? "preview" : "result";
}
export function isWaitingStatus(status) {
    return WAITING_STATUSES.includes(status);
}
export function isTerminalStatus(status) {
    return TERMINAL_STATUSES.includes(status);
}
export function totalFieldsToModify(request) {
    return request?.targets.reduce((sum, target) => sum + (target.forecast?.fieldsModified ?? 0), 0) ?? 0;
}
function servicesWithImpactStatus(request, status) {
    return request?.targets.filter((target) => target.impactStatus === status).map((target) => target.serviceCode) ?? [];
}
/** A participant whose impact failed is never asked to apply: its rules would fail the same way. */
export function failedImpactServices(request) {
    return servicesWithImpactStatus(request, "Failed");
}
export function servicesToProcess(request) {
    return request?.targets.filter((target) => target.impactStatus !== "Failed").length ?? 0;
}
export function timedOutImpactServices(request) {
    return servicesWithImpactStatus(request, "TimedOut");
}
